import { CustomButton, Modal } from '@ui-kit'
import React, { useState } from 'react'
import EPRQueryModal from './ERPQueryModal'
import { FieldValues } from 'react-hook-form'
import { NAMESPACES } from '../../utils/constants'

const EPRQueryButton: React.FC<{
  patientData: FieldValues
  metaData: { layout_id: string; entity_id: string; entity_name: string }
  pharmacyEntityName?: string
  disabled?: boolean
}> = ({ patientData, metaData, disabled, pharmacyEntityName }) => {
  const [queryModalVisible, setQueryModalVisible] = useState<boolean>(false)

  return (
    <>
      <CustomButton
        onClick={() => setQueryModalVisible(true)}
        isFilled
        disabled={disabled}
      >
        <span>{NAMESPACES.EPR_PATIENT_REQUEST}</span>
      </CustomButton>
      {queryModalVisible ? (
        <Modal
          isOpen={queryModalVisible}
          closeModal={() => {
            setQueryModalVisible(false)
          }}
          isDragable
        >
          <EPRQueryModal
            patientData={patientData}
            metaData={metaData}
            closeModal={() => setQueryModalVisible(false)}
            pharmacyEntityName={pharmacyEntityName}
          />
        </Modal>
      ) : null}
    </>
  )
}

export default EPRQueryButton
